import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningLead } from '../components/OpeningLead';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatsIncludedSection } from '../components/WhatsIncludedSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen w-full font-sans text-[#111111] bg-[#FAFAF7] selection:bg-[#E8652D] selection:text-white" data-id="element-267">
      <HeroSection data-id="element-268" />
      <OpeningLead data-id="element-269" />
      <ProblemSection data-id="element-270" />
      <MechanismSection data-id="element-271" />
      <WhatsIncludedSection data-id="element-272" />
      <PricingSection data-id="element-273" />
      <Footer data-id="element-274" />
    </div>;
}